import { UserProfile } from "@sunrun/sales-experience-shared";
import { LoadingOverlay } from "@sunrun/experience-ui-components";
import { useUserProfile } from "../../providers/UserProfile";
import { CustomerProfileIFrame } from "components/organisms/CustomerProfileIFrame";
import { useHybridToken } from "providers/Auth";

const CustomerProfile = () => {
  const { userProfile: userProfileData } = useUserProfile();
  return <CustomerProfileProtector user={userProfileData} />;
};

const CustomerProfileProtector = ({ user }: { user: UserProfile }) => {
  const hybridToken = useHybridToken();
  if (!hybridToken) {
    return <></>;
  }

  if (!user.userId && !user.contactId) {
    return <LoadingOverlay message="Loading..." />;
  }
  return <CustomerProfileIFrame />;
};

export { CustomerProfile };
